/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SinglePageIntro} from "./NolimitBonusIntroPage";
import {RomanEmpireGameAssets} from "../RomanEmpireGameAssets";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {RomanEmpire} from "../RomanEmpire";

export class RomanEmpireIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.4,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };


    stampConfig: StampConfig = {
        xWays: false,
        xNudge: false,
        volatility: Volatility.HIGH
        //volatility: Volatility.MEDIUM
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    bgBlack:PIXI.Sprite;
    introLogo:PIXI.Sprite;

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(RomanEmpireGameAssets.NEW_INTRO_BACKGROUND_PLATE, RomanEmpireGameAssets.NEW_INTRO_BACKGROUND_PLATE);
        imgLoader.add(RomanEmpireGameAssets.INTRO_BORDER_TILE_TOP, RomanEmpireGameAssets.INTRO_BORDER_TILE_TOP);
        imgLoader.add(RomanEmpireGameAssets.INTRO_BORDER_TILE_Bottom, RomanEmpireGameAssets.INTRO_BORDER_TILE_Bottom);
        imgLoader.add(RomanEmpireGameAssets.GENIE_LAMP, RomanEmpireGameAssets.GENIE_LAMP);
        imgLoader.add(RomanEmpireGameAssets.CLOUD, RomanEmpireGameAssets.CLOUD);
        imgLoader.add(RomanEmpireGameAssets.GENIE_PARADE, RomanEmpireGameAssets.GENIE_PARADE);
        imgLoader.add(RomanEmpireGameAssets.GENIE_PARADE_US, RomanEmpireGameAssets.GENIE_PARADE_US);
        imgLoader.add(RomanEmpireGameAssets.GENIW_WISHES, RomanEmpireGameAssets.GENIW_WISHES);
        imgLoader.add(RomanEmpireGameAssets.GENIW_WISHES_US, RomanEmpireGameAssets.GENIW_WISHES_US);
        imgLoader.add(RomanEmpireGameAssets.INTRO_LOGO, RomanEmpireGameAssets.INTRO_LOGO);
        //imgLoader.add(RomanEmpireGameAssets.NOLIMIT_BONUS_ANIMATION, RomanEmpireGameAssets.NOLIMIT_BONUS_ANIMATION);
        //imgLoader.add(RomanEmpireGameAssets.INTRO_BUY_FEATURE_ICON, RomanEmpireGameAssets.INTRO_BUY_FEATURE_ICON);
        //imgLoader.add(RomanEmpireGameAssets.PROMO_FREESPIN, RomanEmpireGameAssets.PROMO_FREESPIN);


        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        this.bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgBlack.anchor.set(0.5, 0.5);
        this.bgBlack.tint = 0x000000;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpireGameAssets.NEW_INTRO_BACKGROUND_PLATE));
        bgSprite.anchor.set(0.5, 0.5);
        const cloudSprite = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpireGameAssets.CLOUD));
        cloudSprite.blendMode = PIXI.BLEND_MODES.ADD;
        cloudSprite.anchor.set(0.5, 0.65);


        this.background.addChild(this.bgBlack);
        this.background.addChild(bgSprite);
        this.background.addChild(cloudSprite);


        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpireGameAssets.INTRO_BORDER_TILE_TOP));
        topSprite.anchor.set(0.5, 1);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpireGameAssets.INTRO_BORDER_TILE_Bottom));
        bottomSprite.anchor.set(0.5, 0.2);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        this.introLogo = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpireGameAssets.INTRO_LOGO));
        this.introLogo.anchor.set(0.5);
        this.introLogo.scale.set(0.45);
        this.logo.addChild(this.introLogo);


        if (RomanEmpire.api.gameClientConfiguration.isSet) {
            this.pages = [
                new SinglePageIntro(),
            ];
        } else {
            RomanEmpire.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.pages = [
                    new SinglePageIntro(),
                ];
            });
        }
    }

    public onResize():void {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
        NolimitApplication.isLandscape
            ? this.introLogo.position.set(0, bounds.top-15)
            : this.introLogo.position.set(0, -this.introLogo.height);
        let scale= NolimitApplication.isLandscape?0.45:0.7;
        this.introLogo.scale.set(scale);
    }
}